import { FormHelperText } from "@chakra-ui/react";

export function ExtraNote({ extraNote }) {
  return (
    <FormHelperText fontSize={"md"} mt={4}>
      Notlar: {extraNote}
    </FormHelperText>
  );
}
